import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const EXCLUDED_WALLET = '0.0.1380608'; // Launchpad Treasury

/**
 * Fetches all holders and their balances from the backend.
 */
export const fetchHolders = async () => {
  try {
    const response = await axios.get(`${API_URL}/api/holders`);
    return response.data;
  } catch (error) {
    console.error("Error fetching holders:", error);
    throw error;
  }
};

/**
 * Trigger the raffle spin on the backend.
 */
export const spinRaffle = async (token) => {
    try {
        const response = await axios.post(
          `${API_URL}/api/raffle/spin`,
          {},
          token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
        );
        return response.data;
    } catch (error) {
        console.error("Error spinning raffle:", error);
        throw error;
    }
};

export const getLatestWinner = async (tier) => {
    try {
        const response = await axios.get(`${API_URL}/api/raffle/winner`, {
            params: tier ? { tier } : undefined
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching winner:", error);
        return null;
    }
};
